<template>
  <div>
    <b-card v-if="!sent">
      <strong v-html="title"></strong>
      <p v-if="organization.enforce_2fa_mobile">{{ trans('mobile_only_validation') }}</p>
      <p v-else>{{ trans('choose_validation_method') }}</p>
      <b-form-group>
        <b-form-radio v-model="email_or_mobile" :value="user.email" v-if="!organization.enforce_2fa_mobile">
          <strong>{{ trans('receive_email')}}:</strong> {{ hidden_email }}
        </b-form-radio>
        <small class="text-muted" v-if="organization.enforce_2fa_mobile && !user.mobile">
          <i class="fa fa-fw fa-info-circle"></i>
          {{ trans('mobile_validation_required_about') }}
        </small>
        <b-form-radio class="mt-2" v-if="user.mobile" v-model="email_or_mobile" :value="user.mobile">
          <strong>{{ trans('receive_sms')}}:</strong> {{ hidden_mobile }}
        </b-form-radio>
      </b-form-group>
      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
      <b-row>
        <b-col>
          <b-button variant="primary" @click="onRequest" :disabled="busy || !canRequest">
            {{ trans('send') }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="sent">
      <p>{{ trans('client_code_sent') }}</p>
      <b-form-group>
        <b-input
          v-model="code"
          :placeholder="trans('six_digit_code')"
          :disabled="busy"
          @keydown="onVerifyKeydown"
        />
      </b-form-group>
      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
      <div>
        <b-button variant="primary" @click="onVerify" :disabled="busy || !canVerify">
          {{ trans('submit') }}
        </b-button>
      </div>
      <div>
        <b-button variant="link" class="pl-0" @click="sent = !sent; code = null" :disabled="busy">
          {{ trans('send_again') }}?
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>

  export default {
    props: {
      organization: Object,
      user: Object,
      reloadOnSuccess: {
        type: Boolean,
        default: true,
      },
      invoice: Object,
      title: {
        type: String,
        default: trans('2fa_organization')
      },
      type: {
        type: String,
        default: 'client',
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        email_or_mobile: this.user.email,
        code: null,
        sent: false,
        hidden_email: this.hide_email(),
        hidden_mobile: this.user.mobile ? this.hide_mobile() : null
      }
    },
    computed: {
      canRequest() {
        if (this.organization.enforce_2fa_mobile) {
          return !!this.user.mobile
        }
        return !!this.email_or_mobile
      },
      canVerify() {
        return !!this.code && (this.code.length == 6 || this.code.length == 7)
      },
      verifyUrl() {
        return `login/${this.organization.id}/confirm`
      },
    },
    methods: {
      onRequestKeydown(e) {
        if (e.keyCode == 13 && this.canRequest) this.onRequest()
      },
      onRequest() {
        this.busy = true
        this.error = null
        let url = `/login/${this.organization.id}/get-connection-code`
        axios.post(url, {
          email_or_mobile: this.email_or_mobile,
        })
        .then(response => {
          this.busy = false
          this.sent = true
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onVerifyKeydown(e) {
        if (e.keyCode == 13 && this.canVerify) this.onVerify()
      },
      onVerify() {
        this.busy = true
        this.error = null
        axios.post(this.verifyUrl, {
          code: this.code.replace('-', '').replace(' ', ''),
        })
        .then(response => {
          if (this.reloadOnSuccess) {
            let url = response.data
            window.location.href = url
          }
          this.$emit('connected', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      hide_email() {
        var arobas_index = this.user.email.indexOf('@')
        var domain = this.user.email.slice(arobas_index)
        return this.user.email.slice(0, 1)+'...'+this.user.email.slice(arobas_index-1, arobas_index) + domain
      },
      hide_mobile() {
        return 'xxx-xxx-' + this.user.mobile.slice(-4);
      }
    },
    mounted() {
      window.userConnect = this
    },
  }
</script>